import React from 'react';
import Loader from 'react-loader-spinner'

import './Loader.css';

function Spinner(props) {
    return (
        <div className="SpinnerCatalogue">
        <Loader
            type="Oval"
            height={50}
            width={50}
            timeout={3000} //3 secs
        />
    </div>
    );
}

export default Spinner;
